import type { Translatable } from "app/pages/sales-intelligence/types";

import TopNWithCostDropdownItem from "../TopNWithCostDropdownItem/TopNWithCostDropdownItem";

export default class TopNWithCostRemainingDropdownItem extends TopNWithCostDropdownItem {
    getTranslation(): Readonly<Translatable> {
        return {
            key: "si.table-actions-panel.options.top-n.remaining-quota",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
